import { render } from "./ClientDetails.vue?vue&type=template&id=434eb772&scoped=true"
import script from "./ClientDetails.vue?vue&type=script&lang=ts"
export * from "./ClientDetails.vue?vue&type=script&lang=ts"

import "./ClientDetails.vue?vue&type=style&index=0&id=434eb772&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-434eb772"

export default script